import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const ack: CaseReducer<NinchatState> = (state) => state
